<div class="card mt-3">
  <div class="card-header text-uppercase">Histórico de Cargas</div>
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-12">
        <div class="row mb-2">
          <div class="col" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoDe"
                [(ngModel)]="starDate"
                [matDatepicker]="picker"
                placeholder="Período de"
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoAte"
                [(ngModel)]="endDate"
                [matDatepicker]="picker2"
                placeholder="Até"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field>
              <mat-label>Tipos de Carga</mat-label>
              <mat-select [(ngModel)]="loadTypeFilter" name="ticketType">
                <mat-option [value]="null"> (todas) </mat-option>
                <mat-option [value]="1">Fundos (Amplis)</mat-option>
                <mat-option [value]="2">Gestores (Amplis)</mat-option>
                <mat-option [value]="3">Contass de Fundos (Amplis)</mat-option>
                <mat-option [value]="4">Fundos Investidos (Amplis)</mat-option>
                <mat-option [value]="6">Lastros (Amplis)</mat-option>
                <mat-option [value]="7">Fundos (JCOT)</mat-option>
                <mat-option [value]="8">Cotistas (JCOT)</mat-option>
                <mat-option [value]="10">Estoque de Fundos (Amplis)</mat-option>
                <mat-option [value]="11"
                  >Estoque de Renda Fixa (Amplis)</mat-option
                >
                <mat-option [value]="12"
                  >Estoque de Renda Variável (Amplis)</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field>
              <mat-label>Origem</mat-label>
              <mat-select
                [(ngModel)]="triggerTypeFilter"
                name="triggerTypeFilter"
              >
                <mat-option [value]="null"> (todas) </mat-option>
                <mat-option [value]="1">Agendador</mat-option>
                <mat-option [value]="2">Acionamento Manual</mat-option>
                <mat-option [value]="3">Planilha</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col">
            <input
              style="width: 100%; margin-top: 7px"
              type="button"
              value="Buscar"
              data-cy="submit"
              class="btn btn-primary"
              appDebounceClick
              (debounceClick)="getHistory()"
              [debounceTime]="200"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-12">
        <mat-table #table [dataSource]="dataSource">
          <ng-container matColumnDef="FileName">
            <mat-header-cell *matHeaderCellDef>Arquivo</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div>
                <a
                  *ngIf="element.fileName != null && element.fileName != ''"
                  href="javascript:void(0)"
                  (click)="download(element.fileName)"
                >
                  <fa-icon [icon]="faDownload"></fa-icon>
                </a>
                <span *ngIf="element.fileName == null || element.fileName == ''"
                  >-</span
                >
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="UserName">
            <mat-header-cell *matHeaderCellDef>Usuário</mat-header-cell>
            <mat-cell *matCellDef="let element">{{
              element.userName
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="LoadType">
            <mat-header-cell *matHeaderCellDef>Tipo de Carga</mat-header-cell>
            <mat-cell *matCellDef="let element">{{
              element.loadType
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="TriggerTypeName">
            <mat-header-cell *matHeaderCellDef>Origem</mat-header-cell>
            <mat-cell *matCellDef="let element">{{
              element.triggerTypeName
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="CreationDate">
            <mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
            <mat-cell *matCellDef="let element">{{
              element.creationDate | date: "dd/MM/yyyy HH:mm"
            }}</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <div>*ngFor="let item of element.result"</div>
        </mat-table>
        <paginador
          [listedPages]="listedPages"
          [firstItemOnPage]="firstItemOnPage"
          [lastItemOnPage]="lastItemOnPage"
          [totalPages]="totalPages"
          [totalItems]="totalItems"
          [currentPage]="currentPage"
          [itemsPerPage]="[10, 25, 50, 100, 200]"
          (onSearch)="getHistory($event[0], $event[1])"
        ></paginador>
      </div>
    </div>
  </div>
</div>
